"use client";

import { c as _c } from "react/compiler-runtime";
import { useDialogDetails } from "../dialogComponents/DialogProvider";
import type { TitleSwitcherItem } from "@/components/atoms/TitleSwitcher/TitleSwitcher";

/**
 * Returns a list of TitleSwitcher items for switching between properties in
 * the current dialog context. The context list is set when `handleOpenDialog`
 * is called with a `contextItems` array (e.g. from a favorites group card).
 */
export function usePropertyDetailSwitcher(currentSlug) {
  const $ = _c(13);
  const {
    dialogContextItems,
    handleOpenDialog
  } = useDialogDetails();
  if (!dialogContextItems?.length) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = [];
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        items: t0 as TitleSwitcherItem[],
        currentId: undefined
      };
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t0;
  if ($[2] !== currentSlug || $[3] !== dialogContextItems) {
    let t1;
    if ($[5] !== currentSlug) {
      t1 = item => item.slug === currentSlug;
      $[5] = currentSlug;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    t0 = dialogContextItems.find(t1);
    $[2] = currentSlug;
    $[3] = dialogContextItems;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const currentItem = t0;
  let t1;
  if ($[7] !== dialogContextItems || $[8] !== handleOpenDialog) {
    t1 = dialogContextItems.map(item_0 => ({
      id: item_0.slug,
      label: item_0.title,
      onSelect: () => handleOpenDialog(item_0.slug, dialogContextItems)
    }));
    $[7] = dialogContextItems;
    $[8] = handleOpenDialog;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const items = t1;
  const t2 = currentItem?.slug;
  let t3;
  if ($[10] !== items || $[11] !== t2) {
    t3 = {
      items,
      currentId: t2
    };
    $[10] = items;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}